/*!

=========================================================
* Argon Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import { connect } from 'react-redux';
import _ from "lodash";
// reactstrap components
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container
} from "reactstrap";

import { logoutAuth, companyChange } from "services/http/auth";
import * as storage from "services/utility/storage";
import * as utils from "services/utility/utils";
import { notificationService } from "services/notifications/NotificationService";
import SignalrNotificationAlert from "components/SignalrNotification/signalrNotificationAlert";
import SignalrNotification from "components/SignalrNotification/signalrNotification";
import appConstant from "constants/app";
import { getClient } from "services/http/client/clientDetail";
import SearchClientPopup from 'views/pages/client/popup/SearchClientPopup';

class AdminNavbar extends React.Component {

  state = {
    contractId: "",
    showPopUp: false,
    data: [],
    status: []
  }
  // function that on mobile devices makes the search open
  openSearch = () => {
    document.body.classList.add("g-navbar-search-showing");
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-showing");
      document.body.classList.add("g-navbar-search-show");
    }, 150);
    setTimeout(function () {
      document.body.classList.add("g-navbar-search-shown");
    }, 300);
  };
  // function that on mobile devices makes the search close
  closeSearch = () => {
    document.body.classList.remove("g-navbar-search-shown");
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-show");
      document.body.classList.add("g-navbar-search-hiding");
    }, 150);
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-hiding");
      document.body.classList.add("g-navbar-search-hidden");
    }, 300);
    setTimeout(function () {
      document.body.classList.remove("g-navbar-search-hidden");
    }, 500);
  };

  logout = (e) => {
    this.props.logoutAuth();
    e.preventDefault();

  }

  onHandleChange = (e) => [
    this.setState({
      contractId: e.target.value
    })
  ]

  searchData = () => {


    if (!utils.isNullOrWhiteSpace(this.state.contractId)) {
      let companiesTokens = storage.getLocalStorage(appConstant.TOKENS)
      let tokens = companiesTokens.filter((item => item.code === this.props.companyCode));
      let secondTokens = companiesTokens.filter((item => item.code !== this.props.companyCode));
      let promises = [];
      let obj = [];
      let status = [];


      if (tokens && tokens.length > 0) {
        promises.push(this.getClientList(tokens[0].token, tokens[0].code, 0));
      }

      if (secondTokens && secondTokens.length > 0) {
        promises.push(this.getClientList(secondTokens[0].token, secondTokens[0].code, 0));
      }

      if (tokens && tokens.length > 0) {
        promises.push(this.getClientList(tokens[0].token, tokens[0].code, 1));
      }

      if (secondTokens && secondTokens.length > 0) {
        promises.push(this.getClientList(secondTokens[0].token, secondTokens[0].code, 1));
      }

      if (promises.length > 0) {

        Promise.all(promises).then((values) => {
          let conpanyStatuses = storage.getLocalStorage(appConstant.COMPANIES);
          _.forEach(values, (value) => {

            let statuses = conpanyStatuses.filter((item) => item.code === value.code)
            if (statuses.length > 0) {

              let companyStatus = statuses[0].company.configured_status
              for (let k = 0; k <= companyStatus.length - 1; k++) {

                let data = companyStatus[k];
                data.code = value.code;
                status.push(data)
              }
            }

            if (value.receiveObj && value.receiveObj !== null && value.receiveObj.data.length > 0) {
              for (let i = 0; i <= value.receiveObj.data.length - 1; i++) {
                let data = value.receiveObj.data[i]
                data.code = value.code;
                obj.push(data);
              }
            }
          })
          if (obj.length > 1) {
            this.setState({
              ...this.state,
              showPopUp: true,
              data: obj,
              status: status,
              contractId: ""
            })
          }
          else {
            let showErrorMsg = true;

            _.forEach(values, (item) => {
              if (item.receiveObj && item.receiveObj !== null && item.receiveObj.data.length > 0) {
                this.setState({ contractId: "" });
                showErrorMsg = false;
                this.redirectTo(item.receiveObj.data[0].reference, item.code);
              }
            })
            if(showErrorMsg) {
              notificationService.sendErrorMessage("No results.");
            }
          }
        })
          .catch(() => {
            this.setState({ contractId: "" });
            notificationService.sendErrorMessage("An unexpected error has occurred. Please try again. Contact us at support@debtonator.us if the problem continues.");
          });
      }
    }
  }

  closePopUp = () => {
    this.setState({
      showPopUp: false,
      data: []
    })
  }

  getnameIdRoleBase = (token) => {
    let tokensId = storage.getProfileToken(token);
    return parseInt(tokensId[appConstant.nameIdentifierClaim]);
  }

  getClientList = (token, code, searchMode) => {

    let obj = {
      receiveObj: null,
      code: code
    }
    let clone = { contactId: null, SearchMode: searchMode, ContractId: null, FirstName: null, LastName: null, Phone: null };
    let contractId = this.state.contractId;

    let phoneNum = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (contractId.length > 9 && contractId.match(phoneNum)) {
      contractId = contractId.replace(/[^\d]+/g, '');
    }

    if (!isNaN(contractId) &&
      parseInt(Number(contractId)) === parseInt(contractId)) {

      if (contractId.length > 9) {
        clone.Phone = contractId;
      }
      else {
        clone.ContractId = contractId
      }
    }
    else {
      let words = contractId.split(" ");
      clone.FirstName = words[0];
      clone.LastName = utils.isNullOrWhiteSpace(words[1]) ? null : words[1];
    }

    return new Promise((resolve) => {
      getClient(clone, token).then((response) => {

        if (response.success && response.receiveObj.data.length > 0) {

          return resolve({
            receiveObj: response.receiveObj,
            code: code
          })

        }
        else {

          return resolve(obj);
        }

      }).catch(() => {

        notificationService.sendErrorMessage("An unexpected error has occurred. Please try again. Contact us at support@debtonator.us if the problem continues.");
        return resolve(obj);
      });
    });


  }

  redirectTo = (item, companyCode) => {
    setTimeout(() => {
      this.props.history.push(`/admin/redirect/${item}/${companyCode}`);
    }, 100);
  }

  onKeyUp(event) {
    if (event.charCode === 13) {
      this.searchData();
    }
  }

  changePassword = () => {
    this.props.history.push("/admin/passwordmanage");
  }

  profileManage = () => {
    this.props.history.push('/admin/profilemanage')
  }

  render() {
    const profile = this.props.auth.profile;
    return (
      <>
        <Navbar
          className={classnames(
            "navbar-top navbar-expand border-bottom",
            { "navbar-dark bg-info": this.props.theme === "dark" },
            { "navbar-light bg-secondary": this.props.theme === "light" }
          )}
        >
          <Container fluid>
            <Collapse navbar isOpen={true}>
              <div
                className={classnames(
                  "navbar-search form-inline mr-sm-3",
                  { "navbar-search-light": this.props.theme === "dark" },
                  { "navbar-search-dark": this.props.theme === "light" }
                )}
              >
                <FormGroup className="mb-0">
                  <InputGroup className="input-group-alternative input-group-merge">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fas fa-search" onClick={() => this.searchData()} />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input placeholder="Search" value={this.state.contractId} className="form-control-sm" onKeyPress={(e) => this.onKeyUp(e)} type="text" onChange={(e) => this.onHandleChange(e)} />
                  </InputGroup>
                </FormGroup>
                <button
                  aria-label="Close"
                  className="close"
                  type="button"
                  onClick={this.closeSearch}
                >
                  <span aria-hidden={true}>×</span>
                </button>
              </div>

              <Nav className="align-items-center ml-md-auto" navbar>
                <NavItem className="d-xl-none">
                  <div
                    className={classnames(
                      "pr-3 sidenav-toggler",
                      { active: this.props.sidenavOpen },
                      { "sidenav-toggler-dark": this.props.theme === "dark" }
                    )}
                    onClick={this.props.toggleSidenav}
                  >
                    <div className="sidenav-toggler-inner">
                      <i className="sidenav-toggler-line" />
                      <i className="sidenav-toggler-line" />
                      <i className="sidenav-toggler-line" />
                    </div>
                  </div>
                </NavItem>
                <NavItem className="d-sm-none">
                  <NavLink onClick={this.openSearch}>
                    <i className="ni ni-zoom-split-in" />
                  </NavLink>
                </NavItem>
              </Nav>
              <Nav className="align-items-center ml-auto ml-md-0" navbar>
                <SignalrNotification  {...this.props} />
                <UncontrolledDropdown nav>
                  <DropdownToggle className="nav-link pr-0" color="" tag="a">
                    <Media className="align-items-center">
                      <Media className="ml-2 d-none d-lg-block">
                        <span className="mb-0 text-sm font-weight-bold">
                          {profile.given_name}
                        </span>
                      </Media>
                    </Media>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem className="noti-title" header tag="div">
                      <h6 className="text-overflow m-0">Welcome!</h6>
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => this.profileManage()}
                    >
                      <i className="ni ni-single-02" />
                      <span>My profile</span>
                    </DropdownItem>

                    <DropdownItem
                      onClick={e => this.changePassword(e)}
                    >
                      <i className="fa fa-lock" aria-hidden="true"></i>
                      <span>Change Password</span>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      href="#pablo"
                      onClick={(e) => this.logout(e)}
                    >
                      <i className="ni ni-user-run" />
                      <span>Logout</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
        <div className="alert-notification">
          <SignalrNotificationAlert />
        </div>
        <SearchClientPopup showPopUp={this.state.showPopUp} companyStatus={this.state.status} closePopUp={this.closePopUp} data={this.state.data} history={this.props.history}></SearchClientPopup>
      </>
    );
  }
}
AdminNavbar.defaultProps = {
  toggleSidenav: () => { },
  sidenavOpen: false,
  theme: "dark"
};

AdminNavbar.propTypes = {
  toggleSidenav: PropTypes.func,
  sidenavOpen: PropTypes.bool,
  theme: PropTypes.oneOf(["dark", "light"])
};


const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    companyCode: state.company.code,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logoutAuth: () => dispatch(logoutAuth()),
    companyChange: (code) => dispatch(companyChange(code))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminNavbar)
